import { Typography } from "@mui/material";
import { _CO, _MONTHS } from "../../../utils/constants";
import { createColumn } from "../../../utils/function";
import { _VOL } from "./AgGridSalesDepot";

export const ColumnBuilder = (
  { budgetParameters } = {},
  groupNameProdSplit,
) => {
  const buildColumns = () => {
    const generatedColumns = [];

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "",
          field: "group",
          rowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return params.data.group;
          },
          supressCount: true,
        },
        {
          headerName: "",
          field: "rowName",
          flex: 2,
        },
      ]),
    );

    for (let i = 1; i <= 12; i++) {
      const fiscalMonthIndex = _CO[i];
      generatedColumns.push(
        ...createColumn([
          {
            headerName: _MONTHS[fiscalMonthIndex],
            field: `${fiscalMonthIndex}`,
            editable: (params) => {
              return (
                params &&
                params.data?.group !== groupNameProdSplit &&
                params.data?.group !== _VOL &&
                params.data?.rowName !== "Total Qty"
              );
            },
            headerClass: "month-header",
            aggFunc: "sum",
            flex: 1,
            cellRenderer: (params) => {
              if (params.data?._SPACER === true) {
                return "";
              }

              if (params.data?.group !== groupNameProdSplit) {
                return (
                  <Typography variant="body2">
                    {params.value} <em>T</em>
                  </Typography>
                );
              }
              return params.value;
            },
          },
        ]),
      );
    }

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "TOTAL",
          field: "total",
          editable: (params) => {
            return params && params.data?.group === groupNameProdSplit;
          },
          headerClass: "total-header-col",
          aggFunc: "sum",
          flex: 1,
          cellRenderer: (params) => {
            if (params?.data?._SPACER) {
              return "";
            }

            if (params.data?.group !== groupNameProdSplit) {
              return (
                <Typography variant="body2">
                  {params.value} <em>T</em>
                </Typography>
              );
            } else {
              return (
                <Typography variant="body2">
                  {params.value} <em>%</em>
                </Typography>
              );
            }
          },
        },
      ]),
    );

    return generatedColumns;
  };

  return buildColumns();
};
